import { useContext } from 'react';
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import { type DatabaseExternalFile, type LogEntry } from '@/lib/types';
import ExternalFilesContext from '@/components/FileAttachments/ExternalFilesContext';
import type React from 'react';

type LogEntryExternalFilesContextProviderProps = {
  logEntry: LogEntry;
  children: React.ReactNode;
};

const LogEntryExternalFilesContextProvider = ({
  logEntry,
  children,
}: LogEntryExternalFilesContextProviderProps) => {
  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const externalFiles = Object.values(logEntry.externalFiles);

  return (
    <ExternalFilesContext.Provider
      value={{
        externalFiles,
        externalFilesExternalIds: externalFiles.map(
          externalFile => externalFile.externalFile.externalId,
        ),
        externalFilesEndpoint: `${portfolioItemApiEndpoint}/log-entries/${logEntry.id}/external-files`,
        addExternalFileToLocalState: (
          externalFile: DatabaseExternalFile,
        ): void => {
          setPortfolioItem(portfolioItem => {
            portfolioItem.logEntries[logEntry.id].externalFiles[
              externalFile.id
            ] = externalFile;
          });
        },
        removeExternalFileFromLocalState: (
          externalFile: DatabaseExternalFile,
        ): void => {
          setPortfolioItem(portfolioItem => {
            delete portfolioItem.logEntries[logEntry.id].externalFiles[
              externalFile.id
            ];
          });
        },
      }}
    >
      {children}
    </ExternalFilesContext.Provider>
  );
};

export default LogEntryExternalFilesContextProvider;
